import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import './Footer.css';

function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="app-footer">
      <ul className="footer-list">
        <li className="footer-item">
          <a
            href="https://www.mytheresa.com/to/service/terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            {t('footer.termsOfUse')}
          </a>
        </li>
        <li className="footer-item">
          <a
            href="https://www.mytheresa.com/to/service/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            {t('footer.privacyPolicy')}
          </a>
        </li>
        <li className="footer-item">
          <a
            href="https://www.mytheresa.com/to/service/imprint/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            {t('footer.imprinting')}
          </a>
        </li>
      </ul>
    </footer>
  );
}

export default Footer;
